import { Omit } from '@40seas/entities/common';
import { TenantlessBaseEntityFieldsArray } from '@40seas/models';
import { AuthApplication } from './auth-application.entity';

export class CreateAuthApplicationDto extends Omit(AuthApplication, [
    ...TenantlessBaseEntityFieldsArray,
    'clientSecret',
    'clientId',
    'status',
]) {
    clientSecret?: string;
    clientId?: string;
}

export class CreateAuthApplicationDtoOptions {
    generateClientSecret?: boolean;
    customScopes?: string[];
}
